import React, { SVGAttributes } from "react";

export function SortActiveDesc(p: SVGAttributes<SVGElement>) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...p}
    >
      <path
        d="M8.71005 11.71L11.3001 14.3C11.6901 14.69 12.3201 14.69 12.7101 14.3L15.3001 11.71C15.9301 11.08 15.4801 10 14.5901 10H9.41005C8.52005 10 8.08005 11.08 8.71005 11.71Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function SortInactive(p: SVGAttributes<SVGElement>) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...p}
    >
      <mask
        id="mask0_4632_19246"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="currentColor" />
      </mask>
      <g mask="url(#mask0_4632_19246)">
        <path
          d="M9.42526 10.9999C8.97526 10.9999 8.66292 10.7956 8.48826 10.3869C8.31292 9.9789 8.38359 9.61657 8.70026 9.2999L11.3003 6.6999C11.4003 6.5999 11.5086 6.5249 11.6253 6.4749C11.7419 6.4249 11.8669 6.3999 12.0003 6.3999C12.1336 6.3999 12.2586 6.4249 12.3753 6.4749C12.4919 6.5249 12.6003 6.5999 12.7003 6.6999L15.3003 9.2999C15.6169 9.61657 15.6876 9.9789 15.5123 10.3869C15.3376 10.7956 15.0253 10.9999 14.5753 10.9999H9.42526Z"
          fill="currentColor"
        />
        <path
          d="M8.71005 14.71L11.3001 17.3C11.6901 17.69 12.3201 17.69 12.7101 17.3L15.3001 14.71C15.9301 14.08 15.4801 13 14.5901 13H9.41005C8.52005 13 8.08005 14.08 8.71005 14.71Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}
